import { render, staticRenderFns } from "./centerUserList.vue?vue&type=template&id=4271901c&"
import script from "./centerUserList.vue?vue&type=script&lang=js&"
export * from "./centerUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports